import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import graduateLabels from '@/utils/format-edit/graduateLabels.json'
import lastEducationalBackgroundOptions from '@/utils/format-edit/lastEducationalBackgroundOptions.json'
import {
  buildRirekishoList,
  createInitialEducationalOptions,
  type RirekishoListItem
} from '@/utils/format-edit/educationalBackgroundAuto'


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoEducationalBackgrounds',
  props: {
    year: null,
    month: null,
    day: null
  },
  emits: ["create-educational-background"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'create-educational-background', list: RirekishoListItem[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  year?: number | string
  month?: number | string
  day?: number | string
};




const birthYear = ref<number | string | undefined>(1985)
const birthMonth = ref<number | string | undefined>(1)
const birthDay = ref<number | string | undefined>(1)
const errorMessage = ref('')
const showEducationalDialog = ref(false)
const options = reactive(createInitialEducationalOptions())
watch(
  () => props.year,
  (val) => (birthYear.value = val)
)
watch(
  () => props.month,
  (val) => (birthMonth.value = val)
)
watch(
  () => props.day,
  (val) => (birthDay.value = val)
)
watch(birthYear, (val) => emitter.emit('birth-year-changed', val))
watch(birthMonth, (val) => emitter.emit('birth-month-changed', val))
watch(birthDay, (val) => emitter.emit('birth-day-changed', val))
watch(
  () => options.lastEducationalBackground,
  (newVal) => {
    if (newVal === 'instituteOfTechnologyCollege') {
      options.periods.highSchool.period = 5
      options.periods.highSchool.defaultName =
        '国立〇〇工業高等専門学校　〇〇科'
    } else {
      options.periods.highSchool.period = 3
      options.periods.highSchool.defaultName = '県立〇〇高等学校 普通科'
    }
  }
)
function closeDialog() {
  showEducationalDialog.value = false
}
function autoComplete() {
  errorMessage.value = ''
  const year = birthYear.value
  const month = birthMonth.value
  const day = birthDay.value
  if (!year || !month || !day) {
    errorMessage.value = '生年月日を入力してください'
    return
  }
  emit(
    'create-educational-background',
    buildRirekishoList({
      birthYear: year,
      birthMonth: month,
      birthDay: day,
      options
    })
  )
  closeDialog()
}
onMounted(() => {
  birthYear.value = props.year
  birthMonth.value = props.month
  birthDay.value = props.day
})

return { __sfc: true,props, emit, birthYear, birthMonth, birthDay, errorMessage, showEducationalDialog, options, closeDialog, autoComplete, graduateLabels, lastEducationalBackgroundOptions }
}

})